require('jquery');

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

require('autocompleter');
import autocomplete from 'autocompleter';
//globális definícióhoz
window.autocomplete = autocomplete;

require('@popperjs/core');
require('jquery-ui');
import 'jquery-ui/ui/widgets/dialog.js';
import 'jquery-ui/ui/widgets/tooltip.js';
require('ckeditor4');
require('@fancyapps/fancybox');
require('slugit');
require('select2');
require('datatables');
require('datatables.net-bs4');
require('yadcf');
require('aos');

import AOS from 'aos';
AOS.init();

require('./gdpreg');

require('./bootstrap');